import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useImagesLoaded } from '../../hooks/useImagesLoaded';
import { useShareablesTemplateRoot } from '../../hooks/useShareablesTemplateRoot';
import SkinComponent from './skins';

const useStyles = makeStyles((theme)=> ({
    wrap: {
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        boxSizing: 'border-box',
    },
    watermark: {
        position: 'absolute',
        left: '50%',
        bottom: '30%',
        zIndex: 9999,

        '& img': {
            position: 'relative',
            left: '-50%',
        },
    }
}));

export default function Notable(props) {
    const {
        rootClasses,
        parsedData,
        onImagesLoaded,
    } = useShareablesTemplateRoot(props);
    const classes = Object.assign({}, rootClasses, useStyles(props));
    const {
        image,
        skin,
    } = parsedData || {};
    const loadedBgs = useImagesLoaded([image]);

    useEffect(() => {
        if(loadedBgs && !window.isLoaded) {
            if(typeof onImagesLoaded === 'function') {
                onImagesLoaded();
            } else {
                window.isLoaded = true;
            }
        }
    }, [loadedBgs, onImagesLoaded]);

    if(!parsedData) return null;

    return (
        <>
            <div className={classes.root} id="templateRoot">
                <div className={classes.viewport}>
                    {/*{image && (<div className={classes.wrap}
                        style={{
                            backgroundImage: `url("${image}")`,
                        }}
                    >
                        {watermark && (<div className={classes.watermark}>
                            <img src="./images/watermark-stamp.svg" alt="Watermark" />
                        </div>)}
                    </div>)}*/}

                    <SkinComponent
                        skin={skin}
                        templateContent={parsedData}
                        onImagesLoaded={onImagesLoaded}
                    />
                </div>
            </div>
        </>
    );
}
